import React from 'react';
import {
  FaFilePdf,
  FaTimes,
  FaSync,
  FaExternalLinkAlt,
  FaDownload,
} from 'react-icons/fa';
import styles from './OfferDetailPage.module.css';

interface PdfDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  pdfBlobUrl: string | null;
  onRefresh: () => void;
  loading: boolean;
  offerNumber: string;
}

export function PdfDrawer({ isOpen, onClose, pdfBlobUrl, onRefresh, loading, offerNumber }: PdfDrawerProps): React.JSX.Element | null {
  if (!isOpen) return null;

  const handleDownload = () => {
    if (pdfBlobUrl) {
      const link = document.createElement('a');
      link.href = pdfBlobUrl;
      link.download = `Offer_${offerNumber}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className={styles.pdfOverlay} onClick={onClose}>
      <div className={styles.pdfDrawer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.pdfHeader}>
          <div className={styles.pdfHeaderLeft}>
            <button onClick={onClose} className={styles.pdfCloseBtn} title="Close">
              <FaTimes size={16} />
            </button>
            <h2 className={styles.pdfTitle}>PDF Preview</h2>
          </div>
          <div className={styles.pdfActions}>
            <button
              onClick={onRefresh}
              disabled={loading}
              className={styles.pdfRefreshBtn}
              style={{ cursor: loading ? 'wait' : 'pointer' }}
            >
              <FaSync size={12} />
              {loading ? 'Loading...' : 'Refresh'}
            </button>
            {pdfBlobUrl && (
              <>
                <a
                  href={pdfBlobUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.pdfNewTabLink}
                >
                  <FaExternalLinkAlt size={12} />
                  New tab
                </a>
                <button onClick={handleDownload} className={styles.pdfDownloadBtn}>
                  <FaDownload size={12} />
                  Download
                </button>
              </>
            )}
          </div>
        </div>

        <div className={styles.pdfContent}>
          {loading ? (
            <div className={styles.pdfLoading}>
              <FaFilePdf size={48} className={styles.pdfLoadingIcon} />
              <p style={{ margin: 0 }}>Loading PDF preview...</p>
            </div>
          ) : pdfBlobUrl ? (
            <iframe
              key={pdfBlobUrl}
              src={pdfBlobUrl}
              className={styles.pdfIframe}
              title="PDF Preview"
            />
          ) : (
            <div className={styles.pdfLoading}>
              <FaFilePdf size={48} className={styles.pdfLoadingIcon} />
              <p style={{ margin: 0 }}>Click "Refresh" to load the PDF</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
